import { render, staticRenderFns } from "./RankingsByMatchdayFile.vue?vue&type=template&id=7f23b7c0&scoped=true"
import script from "./RankingsByMatchdayFile.vue?vue&type=script&lang=js"
export * from "./RankingsByMatchdayFile.vue?vue&type=script&lang=js"
import style0 from "./RankingsByMatchdayFile.vue?vue&type=style&index=0&id=7f23b7c0&prod&lang=scss"
import style1 from "./RankingsByMatchdayFile.vue?vue&type=style&index=1&id=7f23b7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23b7c0",
  null
  
)

export default component.exports